import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { defaultImg, leftArrow, vehicle } from "../../common/Assets/imgs";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import { BASE_URL, URLS } from "../../Services/Constant";
import { post, put } from "../../Services/ApiHandler";
import toast from "react-hot-toast";

const AddVehicle = () => {
  const navigation = useNavigate();
  const location = useLocation();
  console.log("location", location);
  const [image, setImage] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isImageRemoved, setIsImageRemoved] = useState(false);

  const data = location?.state?.data;
  console.log("data", data);
  const type = location?.state?.type;
  console.log("type", type);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage({
        file,
        preview: URL.createObjectURL(file),
      });
    }
  };

  const removeImage = () => {
    setImage(null);
    setIsImageRemoved(true);
  };

  const [form, setForm] = useState({
    
    vehicleType: "",
    price: "",
    maxton: "",
   
  });
 

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  useEffect(() => {
    setForm({
      vehicleType: data?.type,
      price: data?.price,
      maxton: data?.max_ton,
    });
    console.log("isEdit", isEdit);

    if (data?.image_url) {
      setImage({
        preview: data.image_url,
        file: null,
      });
    }

    if (type === "view") {
    //   if (isEdit) {
    //   }
    //    else 
        // {
        setIsEdit(type !== "view");
    //   }
    } else {
      setIsEdit(true);
    }
  }, [data, type]);

  const handleSave = async () => {
    console.log("");

  

    const payload = new FormData();
    payload.append("type", form?.vehicleType);
    payload.append("price", form?.price);
    payload.append("max_ton", form?.maxton);

    // 👇 Append image only if new file selected
    if (image?.file) {
      payload.append("image", image.file);
    }

    if (isImageRemoved) {
      payload.append("image", "");
      // OR null depending on backend
    }

    console.log("payload", payload);
    if (type === "add") {
      setIsLoading(true);
      try {
        const res = await post(URLS.VEHICLE_ADD, payload);

        console.log("");
        if (res?.status === "success") {
          toast.success(res.message || "Success");
          setIsLoading(false);
          navigation(-1);
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log("data.id", data.id);

      try {
        setIsLoading(true);
        const res = await put(`${URLS.VEHICLE_EDIT}${data?.id}/`, payload);
        console.log("");
        if (res?.status === "success") {
          toast.success(res.message || "Success");
          navigation(-1);
        }
      } catch (err) {
        console.log("err", err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="add-admin-container">
        {/* Header */}
        <div onClick={() => navigation(-1)} className="admin-header">
          <img src={leftArrow} className="back-icon-arrow" />
          <h2>Vehicle Master</h2>
        </div>
        <div className="image-list">
          {image ? (
            <div className="image-card">
              <img disabled={!isEdit} src={image.preview} alt="vehicle" />
              {isEdit && (
                <button className="remove-btn" onClick={removeImage}>
                  ×
                </button>
              )}
            </div>
          ) : (
            <label className="upload-box">
              <img src={defaultImg} className="imageSize" alt="vehicle" />
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                hidden
                disabled={!isEdit}
              />
            </label>
          )}
        </div>
        {/* Form */}
        <div className="admin-form">
          {/* Row 1 */}
          <div className="form-groups">
            <label>Vehicle Type</label>
            <input
              type="text"
              value={form.vehicleType}
              placeholder="Enter Vehicle Type"
              onChange={(e) => handleChange("vehicleType", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          <div className="form-groups">
            <label>Price (KM)</label>
            <input
              type="text"
              value={form.price}
              placeholder="Enter Price Details"
              onChange={(e) => handleChange("price", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          {/* Row 2 */}
          <div className="form-groups">
            <label>Max Ton</label>
            <input
              type="text"
              value={form.maxton}
              placeholder="Enter max ton"
              onChange={(e) => handleChange("maxton", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* Buttons */}
          <div className="admin-actions">
            {type === "view" && !isEdit && (
              <button onClick={() => setIsEdit(true)} className="edit-btn">
                Edit
              </button>
            )}
            {(type === "add" || isEdit) && (
              <button onClick={handleSave} className="save-btn">
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Save"
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVehicle;
